import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="M8.092 22.052c-1.512.992-3.52-.092-3.52-1.9V4.705c0-1.808 2.008-2.892 3.52-1.9l11.768 7.723a2.273 2.273 0 0 1 0 3.801L8.092 22.052Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;